import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TabViewModule } from 'primeng/primeng';
import { FieldsetModule } from 'primeng/primeng';
import { MenuItem } from 'primeng/primeng';
import { SelectItem } from 'primeng/primeng';
import { PadraoService } from '../../service/padrao.service';
import { Message } from 'primeng/primeng';
import { SliderModule } from 'primeng/primeng';
import { CrudLotacaoUsuarioEtapa1Component } from '../';
import { CrudLotacaoUsuarioEtapa2Component } from '../';
import { BaseCrudComponent } from "../../base/base-crud.component";
import { environment } from 'environments/environment';
import { concat } from 'rxjs/observable/concat';

@Component({
    selector: 'lotacao-usuario-crud',
    templateUrl: 'lotacao-usuario-crud.component.html'
})

export class CrudLotacaoUsuarioComponent extends BaseCrudComponent {

    controllerName = 'usuarioLotacaoPerfil';

    SistemaOptions: SelectItem[] = [];
    PerfilOptions: SelectItem[] = [];

    dataExpiracao: Date;

    filtro = this.formBuilder.group({
        possui: [this.controllerName],
        query: [null]
    });

    cadastro = this.formBuilder.group({
        nome: [null, [Validators.required]],
        cpf: [null, [Validators.required]],
        email: [null, [Validators.required]],
        lotacao: [null, [Validators.required]],
        situacao: [null, [Validators.required]],
        id_lotacao: [null, [Validators.required]],
        id_usuario: [null, [Validators.required]],
        id_sistema: [null, [Validators.required]],
        id_status: [1],
        justificativa_solicitacao: [null],
        id_perfil: [null, [Validators.required]],
        data_expiracao: [null, [Validators.required]],
        id: [null]
    });

    init() {
        this.service.ListarTodos('sistema', 'Unidades').subscribe(
            data =>  this.SistemaOptions = data
        );

        this.cadastro.get("id_sistema").valueChanges.subscribe(x => {
            this.service.ListarTodos('perfil', { id_sistema: x, query: 'ativo' }).subscribe(
                data => {
                    this.PerfilOptions = data;
                    this.cadastro.get('id_perfil').enable();
                }
            );
        });
        super.init();
        super.afterLoad();
    }


    afterLoad() {
        if (this.acao !== 'cadastrar') {
            this.cadastro.get("nome").setValue(this.obj.usuario.nome);
            this.cadastro.get("cpf").setValue(this.obj.usuario.cpf);
            this.cadastro.get("email").setValue(this.obj.usuario.email);
            this.cadastro.get("lotacao").setValue(this.obj.lotacao.nome);
            this.cadastro.get("situacao").setValue(this.obj.usuario.situacao.nome);
            this.cadastro.get("id_sistema").setValue(this.obj.perfil.id_sistema);
            this.cadastro.get("id_perfil").setValue(this.obj.perfil.id);
            this.cadastro.get("id_status").setValue(this.obj.id_status);
            this.cadastro.get("justificativa_solicitacao").setValue(this.obj.justificativa_solicitacao);
        }
        let d = new Date(this.cadastro.value.data_expiracao);
        if (d.getMonth()+1 + "/" + d.getDate() + "/" + d.getFullYear() == "1/1/1"){
          this.cadastro.get("data_expiracao").setValue("");
        }
    }

    finalizar(event: any) {
        this.confirmacao.confirm({
            header: 'Mensagem de Confirmação',
            message: `Atenção! Ao confirmar esta operação, a lotação do usuário será ${this.acao == 'cadastrar' ? 'salva' : 'atualizada'} na base de dados.
            Deseja realmente confirmar esta operação?`,
            accept: () => {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                this.acao === 'cadastrar' ?
                    this.service.Adicionar(this.controllerName, this.cadastro.getRawValue()).subscribe(
                        sucess => {
                            sessionStorage.setItem("msg", "Registro salvo com sucesso.");
                            this.router.navigate(['../'], { relativeTo: this.activatedRoute });
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        },
                        err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            this.showMsg('warn', 'Mensagem de Erro', `Erro ao gravar. ${err._body}`)
                    }) :
                    this.service.Atualizar(this.controllerName, this.cadastro.getRawValue(), {parcial: 1}).subscribe(
                        sucess => {
                            sessionStorage.setItem("msg", "Registro atualizado com sucesso.");
                            this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        },
                        err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            super.showMsg('warn', 'Mensagem de Erro', `Erro ao atualizar. ${err._body}`)
                    });
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/lotacao-usuario/crud/lotacao-usuario-crud.component.ts